module.exports = __webpack_public_path__ + "static/media/ash.69ea927f.jpg";